import React from 'react';
import { FaStar } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

function ProductCard({ product }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product/${product.id}`);
  };

  return (
    <div className="product-card" onClick={handleClick}>
      <img 
        src={product.image} 
        alt={product.name} 
        className="product-image"
      />
      <div className="product-info">
        <h3>{product.name}</h3>
        <p className="product-description">{product.shortDescription}</p>
        <div className="product-rating">
          {[...Array(5)].map((_, index) => (
            <FaStar key={index} />
          ))}
          <span>(5.0)</span>
        </div>
        <p className="product-price">€{product.price.toFixed(2)}</p>
        <button className="view-details-btn">
          Προβολή Λεπτομερειών
        </button>
      </div>
    </div>
  );
}

export default ProductCard;